import { render } from "./RoadmapBanner.vue?vue&type=template&id=28819536&scoped=true"
import script from "./RoadmapBanner.vue?vue&type=script&lang=js"
export * from "./RoadmapBanner.vue?vue&type=script&lang=js"

import "./RoadmapBanner.vue?vue&type=style&index=0&id=28819536&scoped=true&lang=css"

import exportComponent from "/Users/otherview/go/src/github.com/otherview/blockstory/web/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28819536"]])

export default __exports__